import { SelectOptionBase } from "./types";

export const renderOptionLabel = <T extends SelectOptionBase>(option: T) =>
  option.label || option.value;
